<template>

  <div class="einvoice-list-page">
     <KTCodePreview v-bind:title="'Hoá đơn điện tử'"
      > <template v-slot:toolbar
        > <b-row
          > </b-row
        > </template
      > <template v-slot:preview
        > <!-- Filters --> <EInvoiceFilter
          :filter-value="einvoiceFilter"
          :stores="branches"
          @filter="onFilter"
          @reset="onResetFilter"
        /> <!-- Summary row --> <b-row class="mb-3"
          > <b-col cols="6"
            >
            <p
              class="mt-2 text-dark"
              style="font-weight: 500"
            >
               Tổng số: {{ einvoiceTotalItems }}
            </p>
             </b-col
          > <b-col cols="6"
            > <b-pagination
              pills
              size="sm"
              v-show="einvoiceTotalPages >= 2"
              :value="einvoiceFilter.page"
              :per-page="einvoiceFilter.limit"
              :total-rows="einvoiceTotalItems"
              align="right"
              @input="onPageChange"
              class="mt-1"
            ></b-pagination
            > </b-col
          > </b-row
        > <!-- Data Table --> <BulkActionBar
          v-if="hasSelection"
          :selected-count="selectionCount"
          :is-loading="einvoiceBulkIssue && einvoiceBulkIssue.isPreChecking"
          :draft-count="draftCountInSelection"
          :is-delete-loading="isBulkDeleteProcessing"
          @bulk-issue="triggerBulkIssue"
          @clear-selection="clearSelection"
          @bulk-delete="triggerBulkDelete"
        /> <b-skeleton-wrapper :loading="einvoiceIsLoading"
          > <template #loading
            > <b-skeleton-table
              :rows="10"
              :columns="8"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table
            > </template
          > <b-table
            ref="invoiceTable"
            bordered
            hover
            :items="einvoiceList"
            :fields="tableFields"
            :busy="einvoiceIsLoading"
            show-empty
            empty-text="Không có dữ liệu"
            class="einvoice-table"
            @row-clicked="onRowClick"
            tbody-tr-class="cursor-pointer"
            > <!-- Selected checkbox --> <template #cell(_selected)="{ item }"
              > <b-form-checkbox
                v-model="selectedRows"
                :value="item"
                :disabled="!isRowSelectable(item)"
                @click.native.stop
              ></b-form-checkbox
              > </template
            > <template #head(_selected)
              > <b-form-checkbox
                :checked="isAllSelected"
                :indeterminate="isIndeterminate"
                :disabled="!selectableRows.length"
                @change="toggleSelectAll"
                @click.native.stop
              ></b-form-checkbox
              > </template
            > <!-- Invoice No --> <template #cell(invoiceNo)="{ item }"
              >
              <div class="d-flex flex-column">
                 <router-link
                  v-if="getDetailRoute(item)"
                  :to="getDetailRoute(item)"
                  class="font-weight-bold text-primary einvoice-list-invoice-no"
                  :class="getInvoiceIdentity(item).primaryClass"
                  > {{ getInvoiceIdentity(item).primaryText }} </router-link
                > <span
                  v-else
                  class="font-weight-bold text-muted"
                  :class="getInvoiceIdentity(item).primaryClass"
                  > {{ getInvoiceIdentity(item).primaryText }} </span
                > <small
                  class="einvoice-text-meta"
                  :class="getInvoiceIdentity(item).secondaryClass"
                  > {{ getInvoiceIdentity(item).secondaryText }} </small
                >
              </div>
              <br/>
               </template
            > <!-- Sale Invoice ref --> <template #cell(saleInvoiceRef)="{ item }">
              <div class="d-flex flex-column">
                <a
                  v-if="getSaleInvoiceSourceUrl(item)"
                  :href="getSaleInvoiceSourceUrl(item)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="einvoice-source-link"
                  @click.stop
                >{{ item.saleInvoiceCode }}<i class="fas fa-external-link-alt ml-1"></i></a>
                <span
                  v-else
                  class="font-weight-bold"
                >{{ item.saleInvoiceCode }}</span>
                <small
                  v-if="item.contractInvalid"
                  class="einvoice-text-meta text-danger"
                >{{ item.billTypeName || 'Không xác định' }}</small>
                <small
                  v-else
                  class="einvoice-text-meta"
                >{{ item.billTypeName || 'Không xác định' }}</small>
                <hr v-if="item.codeShip" class="my-1">
                <small
                  v-if="item.codeShip"
                  class="einvoice-text-meta"
                  style="color: darkgoldenrod"
                  v-b-tooltip.hover
                  title="Mã vận đơn"
                ><i class="fas fa-truck mr-1" style="font-size: 0.65rem; color: darkgoldenrod"></i>{{ item.codeShip }}</small>
              </div>
            </template
            > <!-- Store --> <template #cell(store)="{ item }">
              <div class="d-flex flex-column">
                <b>{{ item.storeName || '--' }}</b>
                <small
                  v-if="item.companyName"
                  class="einvoice-text-meta"
                >( {{ item.companyName }} )</small>
              </div>
            </template
            > <!-- Customer --> <template #cell(customer)="{ item }"
              >
              <div>
                 <span>{{ item.customerName || 'Khách lẻ' }}</span
                > <br/> <small
                  v-if="item.customerTaxCode"
                  class="text-muted"
                  > MST: {{ item.customerTaxCode }} </small
                >
                <br/>
                 <small
                  v-if="item.customerEmail"
                  class="text-muted"
                  > Email: {{ item.customerEmail }} </small
                >
                <br v-if="item.buyerName"/>
                 <small
                  v-if="item.buyerName"
                  class="text-muted"
                  > Người mua: {{ item.buyerName }} </small
                >
              </div>
               </template
            > <!-- Amount --> <template #cell(totalAmount)="{ item }"
              > <span
                class="einvoice-amount text-right d-block"
                :class="getAmountDisplay(item).toneClass"
                > {{ formatCurrency(item.totalAmount) }} </span
              > <small
                v-if="getAmountDisplay(item).hint"
                class="d-block text-right einvoice-text-meta text-warning"
                > {{ getAmountDisplay(item).hint }} </small
              > </template
            > <!-- Buyer Tax Code (cột đang ẩn — đọc customerTaxCode để khớp response BE) -->
            <template #cell(buyerTaxCode)="{ item }">
              <span v-if="item.customerTaxCode">{{ item.customerTaxCode }}</span>
              <span
                v-else
                class="text-muted"
              >--</span>
            </template
            > <!-- Invoice Date --> <template #cell(invoiceDate)="{ item }"
              > {{ formatInvoiceDateShort(item.invoiceDate) }} </template
            > <!-- Issued At --> <template #cell(issuedAt)="{ item }"
              > {{ item.issuedAt ? formatInvoiceDateShort(item.issuedAt) : '--' }} </template
            > <!-- Status --> <template #cell(status)="{ item }"
              >
              <div class="d-flex flex-column align-items-center">
                 <EInvoiceStatusBadge
                  :status="item.status"
                  size="sm"
                /> <small
                  class="einvoice-text-meta mt-1 text-center"
                  :class="`text-${getReadinessMeta(item).variant}`"
                  > {{ getReadinessMeta(item).text }} </small
                > <small
                  v-if="getBlockerMeta(item)"
                  class="einvoice-text-meta mt-1 text-center"
                  :class="`text-${getBlockerMeta(item).variant}`"
                  > {{ getBlockerMeta(item).text }} </small
                >
                <EinvoiceAdjustmentDraftBadge
                  v-if="item.adjustmentDraft && getAdjustmentDraftDetailHref(item.adjustmentDraft)"
                  :status="item.adjustmentDraft.status"
                  linkable
                  :href="getAdjustmentDraftDetailHref(item.adjustmentDraft)"
                  link-title="Mở chi tiết nháp điều chỉnh (tab mới)"
                  wrapper-class="mt-1"
                  @link-click="openAdjustmentDraftDetail"
                />
              </div>
               </template
            > <!-- Tax Status Indicator --> <template #cell(taxStatus)="{ item }"
              > <span
                v-if="item.taxStatus === 'TAX_ACCEPTED'"
                class="text-success"
                v-b-tooltip.hover
                title="CQT đã chấp nhận"
                > <i class="fas fa-check-circle"></i> </span
              > <span
                v-else-if="item.taxStatus === 'TAX_REJECTED'"
                class="text-danger"
                v-b-tooltip.hover
                :title="item.feedbackContent || 'CQT từ chối'"
                > <i class="fas fa-times-circle"></i> </span
              > <span
                v-else-if="item.taxStatus === 'TAX_PENDING'"
                class="text-warning"
                v-b-tooltip.hover
                title="Đang chờ CQT xử lý"
                > <i class="fas fa-clock"></i> </span
              > <span
                v-else
                class="text-muted"
                > <i class="fas fa-minus"></i> </span
              > </template
            > <!-- Actions --> <template #cell(actions)="{ item }"
              > <b-dropdown
                size="sm"
                variant="link"
                no-caret
                right
                :disabled="hasSelection"
                @click.stop
                > <template #button-content> <i class="fas fa-ellipsis-v text-dark"></i> </template>
                <b-dropdown-item @click.stop="viewDetail(item)"
                  > <i class="fas fa-eye mr-2"></i> Xem chi tiết </b-dropdown-item
                > <!-- Ẩn chức năng này --> <!-- <b-dropdown-item
                  v-if="canEditItem(item)"
                  @click.stop="showEditModal(item)"
                  > <i class="fas fa-pen mr-2 text-warning"></i> Chỉnh sửa </b-dropdown-item
                > --> <b-dropdown-item
                  v-if="canRefreshTaxItem(item)"
                  @click.stop="refreshTaxStatus(item)"
                  > <i class="fas fa-sync-alt mr-2 text-info"></i> Kiểm tra CQT </b-dropdown-item
                > <b-dropdown-item
                  v-if="canDownloadPdfItem(item)"
                  :disabled="isPdfCooldownActive(item)"
                  @click.stop="openPdfViewer(item)"
                  > <i class="fas fa-file-pdf mr-2 text-danger"></i> Xem PDF </b-dropdown-item
                > <b-dropdown-divider v-if="canShowCorrectionActions(item)"></b-dropdown-divider>
                <b-dropdown-item
                  v-if="canCancelItem(item)"
                  @click.stop="showCancelModal(item)"
                  > <i class="fas fa-ban mr-2 text-dark"></i> Huỷ hoá đơn </b-dropdown-item
                > <b-dropdown-item
                  v-if="canAdjustItem(item)"
                  @click.stop="showAdjustModal(item)"
                  > <i class="fas fa-edit mr-2 text-info"></i> Điều chỉnh </b-dropdown-item
                > <b-dropdown-item
                  v-if="canReplaceItem(item)"
                  @click.stop="showReplaceModal(item)"
                  > <i class="fas fa-exchange-alt mr-2 text-warning"></i> Thay thế </b-dropdown-item
                > <b-dropdown-divider v-if="canDeleteDraftItem(item)"></b-dropdown-divider
                > <b-dropdown-item
                  v-if="canDeleteDraftItem(item)"
                  :disabled="isDeleting"
                  @click.stop="confirmDeleteDraft(item)"
                  > <i class="fas fa-trash-alt mr-2 text-danger"></i> Xoá nháp </b-dropdown-item
                > </b-dropdown
              > </template
            > </b-table
          > </b-skeleton-wrapper
        > <!-- Bottom pagination --> <b-row v-if="einvoiceTotalPages >= 2"
          > <b-col
            > <b-pagination
              pills
              size="sm"
              :value="einvoiceFilter.page"
              :per-page="einvoiceFilter.limit"
              :total-rows="einvoiceTotalItems"
              align="right"
              @input="onPageChange"
            ></b-pagination
            > </b-col
          > </b-row
        > <!-- Edit Modal --> <EInvoiceEditModal
          ref="editModal"
          :invoice="selectedDraftEditorSeed"
          @updated="onActionComplete"
          @issued="onActionComplete"
        /> <!-- Cancel Modal --> <EInvoiceCancelModal
          ref="cancelModal"
          :invoice="selectedActionSubject"
          @canceled="onActionComplete"
        /> <!-- Adjust Modal --> <EInvoiceAdjustModal
          ref="adjustModal"
          :invoice="selectedActionSubject"
          @adjusted="onActionComplete"
        /> <!-- Replace Modal --> <EInvoiceReplaceModal
          ref="replaceModal"
          :invoice="selectedActionSubject"
          @replaced="onActionComplete"
        /> <PdfViewerModal ref="pdfViewer" /> <BulkIssueModal
          ref="bulkIssueModal"
          @closed="onBulkIssueClosed"
        /> <BulkDeleteModal
          ref="bulkDeleteModal"
          @closed="onBulkDeleteClosed"
        /> </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import {
    EINVOICE_DELETE_DRAFT,
    EINVOICE_BULK_DELETE_DRAFT,
    EINVOICE_FETCH_LIST,
    EINVOICE_REFRESH_TAX,
    EINVOICE_RESET_FILTER,
    EINVOICE_SET_FILTER,
  } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { EINVOICE_STATUS, EINVOICE_SALE_TYPE } from '@/utils/einvoice.enum'
  import Swal from 'sweetalert2'
  import { getToastInstance } from '@/utils/toastHelper'
  import PdfViewerModal from '@/view/components/pdf-viewer/PdfViewerModal.vue'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import commonMixin from '@/view/mixins/api-common.mixins'
  import BulkActionBar from './components/BulkActionBar.vue'
  import BulkIssueModal from './components/BulkIssueModal.vue'
  import BulkDeleteModal from './components/BulkDeleteModal.vue'
  import EInvoiceAdjustModal from './components/EInvoiceAdjustModal.vue'
  import EInvoiceCancelModal from './components/EInvoiceCancelModal.vue'
  import EInvoiceEditModal from './components/EInvoiceEditModal.vue'
  import EInvoiceFilter from './components/EInvoiceFilter.vue'
  import EInvoiceReplaceModal from './components/EInvoiceReplaceModal.vue'
  import EInvoiceStatusBadge from './components/EInvoiceStatusBadge.vue'
  import EinvoiceAdjustmentDraftBadge from './components/EinvoiceAdjustmentDraftBadge.vue'
  import einvoiceMixin from './mixins/einvoice.mixin'
  import useBulkSelection from './mixins/useBulkSelection'
  import {
    buildListAmountDisplay,
    buildListBlockerMeta,
    buildListInvoiceIdentity,
    buildListReadiness,
  } from './utils/listDisplay.utils'
  import { buildActionSubject, buildDraftEditorSeed } from './utils/einvoiceViewModel.selectors'
  import { resolveInvoiceIssuedPdfReadiness } from './utils/pdfReadiness.utils'
  import { buildEInvoicePdfViewerConfig } from './utils/pdfViewer.utils'
  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  export default {
    name: 'EInvoiceList',
    components: {
      KTCodePreview,
      EInvoiceFilter,
      EInvoiceStatusBadge,
      EinvoiceAdjustmentDraftBadge,
      EInvoiceEditModal,
      EInvoiceCancelModal,
      EInvoiceAdjustModal,
      EInvoiceReplaceModal,
      PdfViewerModal,
      BulkActionBar,
      BulkIssueModal,
      BulkDeleteModal,
    },
    mixins: [commonMixin, einvoiceMixin, useBulkSelection],
    data() {
      return {
        STATUS: EINVOICE_STATUS,
        branches: [],
        selectedInvoice: null,
        pdfCooldownTickMs: Date.now(),
        pdfCooldownTimer: null,
        isDeleting: false,
      }
    },
    computed: {
      /**
       * True when at least one selected row has DRAFT status.
       * Controls visibility of the "Xóa hàng loạt hóa đơn nháp" dropdown item.
       */
      hasDraftInSelection() {
        return this.selectedRows.some((row) => row?.status === EINVOICE_STATUS.DRAFT)
      },
      /**
       * Count of selected rows eligible for bulk delete:
       * - status === DRAFT
       * - not contractInvalid
       *
       * Used to populate :draft-count on BulkActionBar.
       * Rows with contractInvalid land in the "blocked" bucket inside
       * BulkDeleteModal, so they must not count toward the draft total.
       */
      draftCountInSelection() {
        return this.selectedRows.filter(
          (row) => row?.status === EINVOICE_STATUS.DRAFT && !row?.contractInvalid,
        ).length
      },
      /**
       * True while the BulkDeleteModal is actively deleting (phase === 'processing').
       * Drives the :is-delete-loading prop on BulkActionBar.
       */
      isBulkDeleteProcessing() {
        return this.$store.getters.einvoiceBulkDelete?.phase === 'processing'
      },
      selectedActionSubject() {
        return buildActionSubject(this.selectedInvoice || {})
      },
      selectedDraftEditorSeed() {
        return buildDraftEditorSeed(this.selectedInvoice || {})
      },
      tableFields() {
        const base = [
          {
            key: '_selected',
            label: '',
            thStyle: { width: '40px' },
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'invoiceNo',
            label: 'Số hoá đơn',
            thClass: 'text-center',
            tdClass: '',
            thStyle: { width: '140px' },
          },
          {
            key: 'saleInvoiceRef',
            label: 'Hóa đơn nguồn',
            thClass: 'text-center',
            thStyle: { width: '130px' },
          },
          {
            key: 'store',
            label: 'Chi nhánh',
            thClass: 'text-center',
            thStyle: { minWidth: '120px' },
          },
          {
            key: 'customer',
            label: 'Khách hàng',
            thClass: 'text-center',
            thStyle: { minWidth: '160px' },
          },
          {
            key: 'totalAmount',
            label: 'Tổng tiền',
            thClass: 'text-center',
            tdClass: 'text-right',
            thStyle: { width: '130px' },
          },
          // {
          //   key: 'buyerTaxCode',
          //   label: 'MST',
          //   thClass: 'text-center',
          //   tdClass: 'text-center',
          //   thStyle: { width: '110px' },
          // },
          {
            key: 'invoiceDate',
            label: 'Ngày HĐ',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '100px' },
          },
          {
            key: 'issuedAt',
            label: 'Ngày phát hành',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '130px' },
          },
          {
            key: 'status',
            label: 'Trạng thái',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '140px' },
          },
          {
            key: 'taxStatus',
            label: 'CQT',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '60px' },
          },
          {
            key: 'actions',
            label: '',
            thStyle: { width: '50px' },
            tdClass: 'text-center',
          },
        ]
        return base
      },
    },
    created() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Hoá đơn điện tử' }])
      this.startPdfCooldownTicker()
      this.fetchBranches()
      this.$store.dispatch(EINVOICE_FETCH_LIST)
    },
    beforeDestroy() {
      this.stopPdfCooldownTicker()
    },
    methods: {
      startPdfCooldownTicker() {
        this.stopPdfCooldownTicker()
        this.pdfCooldownTimer = setInterval(() => {
          this.pdfCooldownTickMs = Date.now()
        }, 1000)
      },
      stopPdfCooldownTicker() {
        if (this.pdfCooldownTimer) {
          clearInterval(this.pdfCooldownTimer)
        }
        this.pdfCooldownTimer = null
      },
      canEditItem(item) {
        return this.canEditInvoiceByContext(item)
      },
      getInvoiceIdentity(item) {
        return buildListInvoiceIdentity(item)
      },
      getSaleInvoiceSourceUrl(item) {
        if (item?.contractInvalid || !item?.saleInvoiceCode) return null

        const code = String(item.saleInvoiceCode).trim()
        if (!code) return null

        if (item.saleType === EINVOICE_SALE_TYPE.WHOLESALE) {
          return `#/wholesale-invoice/update-wholesale-invoice?id=${code}`
        }
        if (item.saleType === EINVOICE_SALE_TYPE.RETAIL) {
          return `#/bills/update-bill?id=${code}`
        }

        return null
      },
      getReadinessMeta(item) {
        return buildListReadiness(item)
      },
      getBlockerMeta(item) {
        return buildListBlockerMeta(item)
      },
      getAmountDisplay(item) {
        return buildListAmountDisplay(item)
      },

      canRefreshTaxItem(item) {
        return this.canRefreshTaxByContext(item)
      },

      canDownloadPdfItem(item) {
        return this.canDownloadPdfByContext(item)
      },
      getIssuedPdfReadinessMeta(item) {
        return resolveInvoiceIssuedPdfReadiness(item || {}, this.pdfCooldownTickMs)
      },
      isPdfCooldownActive(item) {
        return this.getIssuedPdfReadinessMeta(item).isCooldownActive
      },

      canShowCorrectionActions(item) {
        return this.canCancelItem(item) || this.canAdjustItem(item) || this.canReplaceItem(item)
      },

      canCancelItem(item) {
        return this.canCancelByContext(item)
      },

      canAdjustItem(item) {
        return this.canAdjustByContext(item)
      },

      canReplaceItem(item) {
        return this.canReplaceByContext(item)
      },

      canDeleteDraftItem(item) {
        return this.canDeleteDraftByContext(item)
      },

      async confirmDeleteDraft(item) {
        const result = await Swal.fire({
          title: 'Xoá bản nháp?',
          text: 'Bản nháp sẽ bị xoá vĩnh viễn. Hành động này không thể hoàn tác.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#F64E60',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xoá nháp',
          cancelButtonText: '<span style="color:#464E5F">Huỷ</span>',
          reverseButtons: true,
        })
        if (result.isConfirmed) {
          await this.deleteDraft(item)
        }
      },

      async deleteDraft(item) {
        if (this.isDeleting) return
        const context = this.resolveCanonicalItemContext(item)
        if (!context) return

        this.isDeleting = true
        try {
          await this.$store.dispatch(EINVOICE_DELETE_DRAFT, { ...context })
          makeToastSuccess('Đã xoá bản nháp thành công')
        } catch (err) {
          makeToastFailure(err?.message || 'Xoá bản nháp thất bại')
        } finally {
          this.isDeleting = false
        }
      },

      async fetchBranches() {
        try {
          const result = await this.fetchStoreByUser()
          this.branches = result.stores || []
        } catch {
          this.branches = []
        }
      },

      async onFilter(filterPayload) {
        this.clearSelection()
        try {
          await this.$store.dispatch(EINVOICE_SET_FILTER, filterPayload)
          const error = this.$store.getters.einvoiceError
          if (error) {
            makeToastFailure(error)
          }
        } catch (err) {
          makeToastFailure(err?.message || 'Lọc dữ liệu thất bại')
        }
      },

      async onResetFilter() {
        this.clearSelection()
        try {
          await this.$store.dispatch(EINVOICE_RESET_FILTER)
          const error = this.$store.getters.einvoiceError
          if (error) {
            makeToastFailure(error)
          } else {
            makeToastSuccess('Đã đặt lại bộ lọc')
          }
        } catch (err) {
          makeToastFailure(err?.message || 'Đặt lại bộ lọc thất bại')
        }
      },

      onPageChange(page) {
        if (page === this.einvoiceFilter.page) return
        this.clearSelection()
        this.$store.dispatch(EINVOICE_SET_FILTER, { page })
      },

      onRowClick(item) {
        const detailRoute = this.getDetailRoute(item, { notify: true })
        if (!detailRoute) return

        this.$router.push(detailRoute)
      },

      viewDetail(item) {
        const detailRoute = this.getDetailRoute(item, { notify: true })
        if (!detailRoute) return

        this.$router.push(detailRoute)
      },

      async openPdfViewer(item) {
        if (this.isPdfCooldownActive(item)) {
          const remainingSeconds = Math.max(
            1,
            this.getIssuedPdfReadinessMeta(item).remainingSeconds || 0,
          )
          makeToastFailure(`PDF đang được chuẩn bị. Vui lòng thử lại sau ${remainingSeconds} giây.`)
          return
        }

        try {
          const pdfConfig = buildEInvoicePdfViewerConfig(this.$store, item)
          console.log('[openPdfViewer] item:', item)
          console.log('[openPdfViewer] pdfConfig:', {
            ...pdfConfig,
            loadPdf: '[function]',
          })
          await this.$refs.pdfViewer.open(pdfConfig)
        } catch (err) {
          makeToastFailure(err?.message || 'Không thể mở PDF hoá đơn')
        }
      },

      async refreshTaxStatus(item) {
        try {
          const context = this.resolveCanonicalItemContext(item)
          if (!context) return

          await this.$store.dispatch(EINVOICE_REFRESH_TAX, {
            ...context,
          })
          makeToastSuccess('Đã cập nhật trạng thái CQT')
          this.$store.dispatch(EINVOICE_FETCH_LIST)
        } catch (err) {
          makeToastFailure(err?.message || 'Kiểm tra CQT thất bại')
        }
      },

      showEditModal(item) {
        this.selectedInvoice = item
        this.$nextTick(() => {
          this.$refs.editModal.show()
        })
      },
      showCancelModal(item) {
        this.selectedInvoice = item
        this.$nextTick(() => {
          this.$refs.cancelModal.show()
        })
      },

      showAdjustModal(item) {
        this.selectedInvoice = item
        this.$nextTick(() => {
          this.$refs.adjustModal.show()
        })
      },

      showReplaceModal(item) {
        this.selectedInvoice = item
        this.$nextTick(() => {
          this.$refs.replaceModal.show()
        })
      },

      getRowSelectionKey(row) {
        return row?.salesInvoiceId || row?.id || null
      },
      isRowSelectable(item) {
        return Boolean(!item?.contractInvalid && item?.saleType && this.getRowSelectionKey(item))
      },
      resolveCanonicalItemContext(item, { notify = true } = {}) {
        if (item?.contractInvalid) {
          if (notify) {
            makeToastFailure('Không thể mở chi tiết vì loại hóa đơn không hợp lệ.')
          }
          return null
        }

        const salesInvoiceId = String(item?.salesInvoiceId || '').trim()
        const saleType = String(item?.saleType || '').trim()

        if (salesInvoiceId && saleType) {
          return {
            salesInvoiceId,
            saleType,
          }
        }

        if (notify) {
          makeToastFailure(
            'Thiếu salesInvoiceId/saleType theo contract canonical. Vui lòng tải lại danh sách và thử lại.',
          )
        }

        return null
      },
      getDetailRoute(item, { notify = false } = {}) {
        const context = this.resolveCanonicalItemContext(item, { notify })
        if (!context) return null

        return {
          name: 'einvoice-detail',
          params: { salesInvoiceId: context.salesInvoiceId },
          query: { saleType: context.saleType },
        }
      },

      resolveBulkIssueInvoiceType(row) {
        if (row?.contractInvalid) return null

        const normalizedSaleType = String(row?.saleType || '')
          .trim()
          .toUpperCase()

        if (!normalizedSaleType) return null

        if (
          normalizedSaleType.includes('WHOLESALE') ||
          normalizedSaleType.includes('FAST_PORTAL') ||
          normalizedSaleType.includes('PORTAL') ||
          normalizedSaleType.includes('B2B')
        ) {
          return 'wholesale'
        }

        if (
          normalizedSaleType.includes('RETAIL') ||
          normalizedSaleType.includes('FAST_POS') ||
          normalizedSaleType.includes('POS')
        ) {
          return 'retail'
        }

        return null
      },

      triggerBulkIssue() {
        if (!this.hasSelection) return

        const selectedRows = this.selectedRows.filter((row) => this.isRowSelectable(row))
        if (!selectedRows.length) {
          makeToastFailure('Không tìm thấy salesInvoiceId hợp lệ trong danh sách đã chọn.')
          return
        }

        const laneSet = new Set(selectedRows.map((row) => this.resolveBulkIssueInvoiceType(row)))
        laneSet.delete(null)

        if (!laneSet.size) {
          makeToastFailure('Không xác định được lane hóa đơn điện tử của danh sách đã chọn.')
          return
        }

        if (laneSet.size > 1) {
          makeToastFailure(
            'Không thể phát hành chung hóa đơn bán lẻ và bán buôn. Vui lòng tách thành 2 batch riêng.',
          )
          return
        }

        const [invoiceType] = laneSet
        if (invoiceType === 'retail' && !this.canIssueRetail()) {
          makeToastFailure('Bạn không có quyền phát hành hàng loạt hóa đơn bán lẻ.')
          return
        }

        if (invoiceType === 'wholesale' && !this.canIssueWholesale()) {
          makeToastFailure('Bạn không có quyền phát hành hàng loạt hóa đơn bán buôn.')
          return
        }

        this.$refs.bulkIssueModal.open({
          invoiceType,
          action: 'issue',
          salesInvoiceIds: selectedRows.map((row) => row.salesInvoiceId || row.id),
        })
      },

      onBulkIssueClosed() {
        this.clearSelection()
        this.$store.dispatch(EINVOICE_FETCH_LIST)
      },

      /**
       * Validate selection lane consistency, then open the BulkDeleteModal.
       * Shows a toast if the selection contains mixed lanes (retail + wholesale).
       */
      triggerBulkDelete() {
        if (!this.hasSelection) return

        const selectedRows = this.selectedRows.filter((row) => this.isRowSelectable(row))
        if (!selectedRows.length) {
          makeToastFailure('Không tìm thấy salesInvoiceId hợp lệ trong danh sách đã chọn.')
          return
        }

        const laneSet = new Set(selectedRows.map((row) => this.resolveBulkIssueInvoiceType(row)))
        laneSet.delete(null)

        if (!laneSet.size) {
          makeToastFailure('Không xác định được lane hóa đơn điện tử của danh sách đã chọn.')
          return
        }

        if (laneSet.size > 1) {
          makeToastFailure(
            'Không thể xóa chung hóa đơn bán lẻ và bán buôn. Vui lòng tách thành 2 batch riêng.',
          )
          return
        }

        const [saleType] = laneSet // 'retail' | 'wholesale'
        this.$refs.bulkDeleteModal.open({ selectedRows, saleType })
      },

      /**
       * Handler called when BulkDeleteModal emits 'closed'.
       * Clears selection and refreshes the list.
       */
      onBulkDeleteClosed() {
        this.clearSelection()
        this.$store.dispatch(EINVOICE_FETCH_LIST)
      },

      showExportExcel() {
        // Reuse existing ExcelExportModal pattern
        makeToastFailure('Chức năng xuất Excel đang phát triển')
      },

      onActionComplete() {
        this.$store.dispatch(EINVOICE_FETCH_LIST)
      },

      getAdjustmentDraftDetailHref(draft) {
        if (draft?.id == null) return null
        const { href } = this.$router.resolve({
          name: 'adjustment-draft-detail',
          params: { draftId: String(draft.id) },
        })
        return href || null
      },

      openAdjustmentDraftDetail(event) {
        event?.stopPropagation?.()
      },

    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-list-page {
  .einvoice-table {
    font-size: 0.875rem; // $einvoice-type-base

    ::v-deep {
      th {
        vertical-align: middle;
        background-color: #f3f6f9;
        font-size: 0.8rem; // $einvoice-type-sm
        font-weight: 600;
        color: #464e5f;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      }
      td {
        vertical-align: middle;
        padding: 0.5rem 0.75rem;
      }
      .cursor-pointer {
        cursor: pointer;
      }
      tr:hover {
        background-color: #f3f6f9 !important;
      }
    }
  }

  // Invoice number in list row — slightly smaller than detail hero
  .einvoice-list-invoice-no {
    font-size: 0.9375rem; // $einvoice-type-md
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  .einvoice-list-field--pending {
    color: #3699ff !important;
    font-style: italic;
  }

  .einvoice-list-amount--warning {
    color: #d97706;
    font-weight: 700;
  }

  // Adjustment status badge — clickable, opens new tab
  .einvoice-adj-badge {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.2em 0.5em;
    border-radius: 0.25rem;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      opacity: 0.85;
      text-decoration: none;
    }
  }

  // Source invoice link - opens in new tab
  .einvoice-source-link {
    display: inline-flex;
    align-items: center;
    font-weight: 700;
    color: #3699ff;
    text-decoration: none;
    transition: color 0.15s ease;

    i {
      font-size: 0.65rem;
      opacity: 0.6;
      transition: opacity 0.15s ease;
    }

    &:hover {
      color: #1e6fd9;
      text-decoration: underline;

      i {
        opacity: 1;
      }
    }
  }
}
</style>
